import { useLocation, useNavigate } from "react-router-dom";

import StickyHeader from "../../../../components/Layout/StickyHeader";
import BottomGroup from "../../../../components/Button/Group";
import CommonButton from "../../../../components/Button";

import spaceReservationOk from "../../../../assets/img/space-reservation-ok.png";

type Props = {};

export default function GoodsRequestConfirm(props: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="px-5 h-[90vh] pb-10">
      <StickyHeader
        title="사무용품 신청"
        onBackClick={() => navigate("/view")}
      />
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col h-content justify-center">
          <div className="flex flex-col items-center py-2.5">
            <img
              src={spaceReservationOk}
              alt="접수 완료"
              className="h-[100px] mb-[25px]"
            />
            <div className="flex flex-row text-2xl font-semibold pb-2.5 leading-[140%]">
              접수 완료
            </div>
            <div className="flex flex-row text-brand-label-text text-sm text-center leading-[18px] whitespace-pre-line">
              {
                "샌디매니저가 접수 과정에서 추가 정보가 필요할 경우\n휴대폰으로 연락드릴 수도 있어요"
              }
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <div className="flex flex-col py-5 px-2.5 bg-[#F7F7F7] items-center text-center font-normal text-sm leading-[24px]">
            업무시간(18시) 이후에 신청된 건은
            <br />
            익일 업무시간에 처리가 되어 피드백이 늦을 수 있어요
          </div>
          <div className="pb-[30px]"></div>
          <BottomGroup className="h-[90px]">
            <div className="flex flex-row gap-2 p-5 !h-[90px]">
              <CommonButton
                className="w-full border border-gray-200 h-bottom-button rounded-none leading-[17px]"
                variant="white"
                title="홈으로"
                onClick={() => navigate("/view")}
              >
                홈으로
              </CommonButton>
              <CommonButton
                className="w-full border border-gray-200 h-bottom-button rounded-none leading-[17px]"
                variant="white"
                onClick={() =>
                  navigate(`/history/service/${location?.state?.id}`, {
                    state: {
                      parentUrl: `/service/goods/confirmed`,
                      parentState: { ...location?.state },
                    },
                  })
                }
              >
                접수 내역 확인
              </CommonButton>
            </div>
          </BottomGroup>
        </div>
      </div>
    </div>
  );
}
